import React from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { useToast } from '@chakra-ui/react'
import { getAppConfigSetting } from '../utils'
import { SCHEDULED_TRANSFERS } from './constants'
import queryKeys from './queryKeys'
import axios, { AxiosError } from 'axios'
import { Alert } from '@apex/component-library'
// TODO: Replace with ui-components toast

export type ScheduleTypes = 'achs' | 'journal' | 'wires' | 'check'
export type TransferDirection = 'deposits' | 'withdrawals' | ''
export type CreateScheduledTransfer = { payload: any; transferType: ScheduleTypes; direction: TransferDirection }

export const buildApiUrl = (type: ScheduleTypes, direction: TransferDirection) => {
  const baseUrl = getAppConfigSetting('apiUrl')
  const addDirection = direction ? `/${direction}` : ''
  return `${baseUrl}${SCHEDULED_TRANSFERS}/${type}${addDirection}`
}

export const postACHScheduleSubmission = (type: ScheduleTypes, direction: TransferDirection) => async (payload: {}) => {
  const { data } = await axios.post(buildApiUrl(type, direction), payload, {
    withCredentials: true
  })
  return data
}

interface Options {
  onMutate?: Function
  onError?: Function
  onSuccess?: Function
  onSettled?: Function
}

export function useCreateScheduleTransfer(type: ScheduleTypes, direction: TransferDirection, options?: Options) {
  const { onMutate, onError, onSuccess, onSettled } = options || {}
  const queryClient = useQueryClient()
  const toast = useToast()
  return useMutation(postACHScheduleSubmission(type, direction), {
    onMutate: (variables) => {
      // Do stuff before post call
      onMutate && onMutate()
    },
    onError: (error: AxiosError, variables, context) => {
      // toasts are set in useInterceptors
      onError && onError()
    },
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.scheduledTransfers)
      toast({
        duration: 8000,
        position: 'top-right',
        variant: 'left-accent',
        status: 'success',
        isClosable: true,
        render: ({ onClose, id }) => (
          <Alert
            sx={{
              width: 340,
              color: 'black',
              bg: 'white',
              boxShadow: '0px 0px 5px 3px rgba(153,153,153,0.5)'
            }}
            direction='column'
            variant='left-accent'
            title='Success!'
            description='Your transfer request is scheduled for processing.'
            status='success'
            isClosable
            dismiss={onClose}
            id={id as string}
          />
        )
      })
      onSuccess && onSuccess()
    },
    onSettled: (data, error, variables, context) => {
      // do stuff after Error or success.
      onSettled && onSettled()
    }
  })
}
